import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidationErrorComponent } from './validation-error/validation-error.component';
import { RouterModule } from '@angular/router';
import { PipesModule } from '../../pipes/pipes.module';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  imports: [RouterModule, CommonModule, DirectivesModule, PipesModule],
  declarations: [ValidationErrorComponent],
  exports: [ValidationErrorComponent],
})
export class ValidationModule {}
